<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ویرایش
            <strong v-text="$lang.exercise"></strong>
          </div>
          <LoadingSpinner :loading="isLoading" />
          <div v-show="!isLoading">
            <b-card no-body="" class="mb-3">
              <div slot="header">
                <strong>{{ $lang.base_info }}</strong>
                <div class="float-right">
                  <b-button
                    @click="isCollpased = !isCollpased"
                    variant="success"
                  >
                    <i aria-hidden="true" class="fa fa-angle-down"></i>
                  </b-button>
                </div>
              </div>
              <b-collapse v-model="isCollpased" class="mt-2">
                <b-col>
                  <b-form @submit.prevent="save" v-show="!isLoading">
                    <b-form-group
                      :label="$lang.caption"
                      label-for="name"
                      :label-cols="12"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.caption"
                        :rules="$v.name.$params"
                      />
                      <b-form-input
                        id="name"
                        type="text"
                        :autocomplete="$lang.caption"
                        :state="$v.name.$dirty ? !$v.name.$error : null"
                        v-model="$v.name.$model"
                      ></b-form-input>

                      <b-form-invalid-feedback id="name-feedback"
                        >{{ $lang.error_required | replace($lang.name) }}
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      :label="$lang.definition"
                      label-for="description"
                      :label-cols="12"
                    >
                      <requiredComponent
                        slot="label"
                        :label="$lang.definition"
                        :rules="$v.description.$params"
                      />
                      <b-form-textarea
                        id="description"
                        :state="
                          $v.description.$dirty ? !$v.description.$error : null
                        "
                        v-model="$v.description.$model"
                        type="text"
                        :autocomplete="$lang.definition"
                        :rows="5"
                      ></b-form-textarea>

                      <b-form-invalid-feedback id="description-feedback">
                        {{ $lang.error_required | replace($lang.definition) }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-row>
                      <b-col class="col-md-6 col-12">
                        <TagComponent
                          category_name="exercise_type"
                          :label="$lang.exerciseType"
                          :parentPermissions="permissions"
                          :parentValue="exercise_type_selected"
                          :requiredLabel="exerciseTypeSelectedRequired"
                          :checkValidation="exerciseTypeSelectedCheckValidation"
                          @updateCheckValidation="
                            exerciseTypeSelectedUpdateCheckValidation
                          "
                          @getSelected="getExerciseTypeSelected"
                        />
                        <TagComponent
                          category_name="exercise_work_environment"
                          :label="$lang.workEnvironment"
                          :parentPermissions="permissions"
                          :parentValue="work_environment_selected"
                          :requiredLabel="workEnvironmentSelectedRequired"
                          :checkValidation="
                            workEnvironmentSelectedCheckValidation
                          "
                          @updateCheckValidation="
                            workEnvironmentSelectedUpdateCheckValidation
                          "
                          @getSelected="getWorkEnvironmentSelected"
                        />
                        <TagComponent
                          category_name="exercise_industry_sector"
                          :label="$lang.industry_sector"
                          :parentPermissions="permissions"
                          :parentValue="industry_sector_selected"
                          :requiredLabel="industrySectorSelectedRequired"
                          :checkValidation="
                            industrySectorSelectedCheckValidation
                          "
                          @updateCheckValidation="
                            industrySectorSelectedUpdateCheckValidation
                          "
                          @getSelected="getIndustrySectorSelected"
                        />
                      </b-col>
                      <b-col class="col-md-6 col-12">
                        <TagComponent
                          category_name="exercise_level"
                          :label="$lang.level"
                          :parentPermissions="permissions"
                          :parentValue="exercise_level_selected"
                          :requiredLabel="exerciseLevelSelectedRequired"
                          :checkValidation="
                            exerciseLevelSelectedCheckValidation
                          "
                          @updateCheckValidation="
                            exerciseLevelSelectedUpdateCheckValidation
                          "
                          @getSelected="getExerciseLevelSelected"
                        />
                        <TagComponent
                          category_name="exercise_business_function"
                          :label="$lang.business_function"
                          :parentPermissions="permissions"
                          :parentValue="business_function_selected"
                          :requiredLabel="businessFunctionSelectedRequired"
                          :checkValidation="
                            businessFunctionSelectedCheckValidation
                          "
                          @updateCheckValidation="
                            businessFunctionSelectedUpdateCheckValidation
                          "
                          @getSelected="getBusinessFunctionSelected"
                        />
                      </b-col>
                      <b-col xs="12" md="12">
                        <requiredComponent
                          slot="label"
                          :label="$lang.exerciseEvaluationGuideTitle"
                          :rules="$v.exerciseEvaluationGuide.$params"
                        />
                        <Editor
                          v-model="exerciseEvaluationGuide"
                          resource="exercise"
                          :resourceId="id"
                        />
                        <b-form-invalid-feedback id="name-feedback">
                          {{
                            $lang.error_required
                              | replace($lang.exerciseEvaluationGuide)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>

                    <div slot="footer" class="form-group form-btn my-3">
                      <b-button
                        class="mr-2"
                        variant="outline-danger"
                        @click="handleBack"
                      >
                        <mdicon name="close" size="20" />
                        {{ $lang.cancelButton }}
                      </b-button>
                      <b-button
                        type="submit"
                        v-if="isAdmin(permissions)"
                        variant="success"
                      >
                        <mdicon name="check" size="20" />
                        {{ $lang.submitButton }}
                      </b-button>
                    </div>
                  </b-form>
                </b-col>
              </b-collapse>
            </b-card>
            <DragTable
              :showAlert="true"
              :titleAlert="titleAlert"
              :prePage="20"
              :url="algorithmUrl"
              ref="searchExerciseAlgorithm"
              :title="$lang.exerciseAlgorithm"
              :dynamicButtons="buttons"
              :keyLang="`algorithm_fields`"
              :order_url="$config.kanoon.exercise_algorithm_order"
              :order_by="`order:asc`"
              :permissionButtons="permissions"
              :editRoute="false"
              :removeLabel="$lang.exercise_remove"
              :hasAdd="isAdmin(permissions, ['admin'])"
              @handleAdd="showAddModal"
            />
            <b-modal
              no-close-on-backdrop
              v-model="view_edit_algorithm"
              size="xl"
              ok-only
              hide-footer
              hide-header
            >
              <AddAlgorithm
                v-if="mode === 'add'"
                isModal
                @modal-end-up="closeEditAlgorithm"
                :entityId="id"
                entity="exercise"
              />
            </b-modal>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AddAlgorithm from "./algorithm/addAlgorithm";
import DragTable from "@/components/base/dragTable";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Editor from "@/components/ckeditor/editor";
import TagComponent from "@/components/tag/tagComponent.vue";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, generateApiUrl, isAdmin } from "@/shared/utils";
import { createPureDom } from "@/shared/utils";

export default {
  name: "edit-exercise",
  inject: ["attachmentRepository"],
  components: {
    DragTable,
    AddAlgorithm,
    Editor,
    LoadingSpinner,
    TagComponent,
  },
  validations: {
    name: {
      required,
    },
    description: {
      required,
    },
    exerciseEvaluationGuide: {},
  },
  data() {
    return {
      isCollpased: false,
      id: this.$route.params.id,
      view_edit_algorithm: false,
      permissions: [],
      exerciseEvaluationGuide: null,
      name: null,
      description: null,
      mode: "",
      isLoading: false,
      exercise_type_selected: null,
      work_environment_selected: null,
      exercise_level_selected: null,
      business_function_selected: null,
      industry_sector_selected: null,
      buttons: [
        {
          id: "0",
          name: "insertExerciseDetail",
          click: this.changeAlgorithm,
        },
        {
          id: "1",
          name: "view",
          click: this.changeAlgorithm,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      exerciseTypeLoading: false,
      businessFunctionLoading: false,
      exerciseLevelLoading: false,
      workEnvironmentLoading: false,
      industrySectorLoading: false,
      exerciseTypeSelectedRequired: false,
      exerciseTypeSelectedCheckValidation: false,
      workEnvironmentSelectedRequired: false,
      workEnvironmentSelectedCheckValidation: false,
      industrySectorSelectedRequired: false,
      industrySectorSelectedCheckValidation: false,
      exerciseLevelSelectedRequired: false,
      exerciseLevelSelectedCheckValidation: false,
      businessFunctionSelectedRequired: false,
      businessFunctionSelectedCheckValidation: false,
    };
  },
  computed: {
    titleAlert() {
      return `<i class='fas fa-info-circle fa-lg mr-1'></i>
        <b>${this.$lang.ac_exercise_activity_alert}</b>`;
    },
    algorithmUrl() {
      return generateApiUrl(["kanoon", "exercise_algorithm"], [this.id]);
    },
  },
  created() {
    /*  this.categoryLoading = true;
    this.isLoading = true; */
    this.fetchData();
  },
  methods: {
    createPureDom,
    pathOr,
    includes,
    renderEumOptions,
    generateApiUrl,
    isAdmin,
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    changeAlgorithm(item) {
      this.$router.push(
        "/ac/exercise/" + item.exercise.id + "/algorithm/edit/" + item.id
      );
    },
    closeEditAlgorithm(refresh = false) {
      this.view_edit_algorithm = false;
      refresh && this.$refs.searchExerciseAlgorithm.fetchData();
    },
    async save() {
      this.exerciseTypeSelectedCheckValidation = true;
      this.workEnvironmentSelectedCheckValidation = true;
      this.industrySectorSelectedCheckValidation = true;
      this.exerciseLevelSelectedCheckValidation = true;
      this.businessFunctionSelectedCheckValidation = true;
      this.$v.$touch();
      if (this.$v.$anyError) return;
      if (this.exerciseTypeSelectedRequired && !this.exercise_type_selected)
        return;
      if (
        this.workEnvironmentSelectedRequired &&
        !this.work_environment_selected
      )
        return;
      if (this.industrySectorSelectedRequired && !this.industry_sector_selected)
        return;
      if (this.exerciseLevelSelectedRequired && !this.exercise_level_selected)
        return;
      if (
        this.businessFunctionSelectedRequired &&
        !this.business_function_selected
      )
        return;

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "exercise_id"], [this.id]);
        const payload = {
          name: this.name,
          description: this.description,
          exercise_guide: this.exerciseEvaluationGuide,
          level_id: pathOr(null, ["value"], this.exercise_level_selected),
          work_environment_id: pathOr(
            null,
            ["value"],
            this.work_environment_selected
          ),
          type_id: pathOr(null, ["value"], this.exercise_type_selected),
          business_function_id: pathOr(
            null,
            ["value"],
            this.business_function_selected
          ),
          industry_sector_id: pathOr(
            null,
            ["value"],
            this.industry_sector_selected
          ),
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      if (!this.id) return;
      try {
        const url = generateApiUrl(["kanoon", "exercise_id"], [this.id]);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.name = pathOr(null, ["name"], data);
        this.description = pathOr(null, ["description"], data);
        this.exerciseEvaluationGuide = createPureDom(
          pathOr(null, ["exercise_guide"], data)
        );

        this.exercise_type_selected = {
          text: pathOr(null, ["type", "caption"], data),
          value: pathOr(null, ["type", "id"], data),
        };
        this.work_environment_selected = {
          text: pathOr(null, ["work_environment", "caption"], data),
          value: pathOr(null, ["work_environment", "id"], data),
        };
        this.industry_sector_selected = {
          text: pathOr(null, ["industry_sector", "caption"], data),
          value: pathOr(null, ["industry_sector", "id"], data),
        };
        this.exercise_level_selected = {
          text: pathOr(null, ["level", "caption"], data),
          value: pathOr(null, ["level", "id"], data),
        };

        this.business_function_selected = {
          text: pathOr(null, ["business_function", "caption"], data),
          value: pathOr(null, ["business_function", "id"], data),
        };
        this.permissions = response.data.permissions;
      } catch (error) {
        this.$generateError(error);
      }
    },
    showAddModal() {
      this.view_edit_algorithm = true;
      this.mode = "add";
    },
    exerciseTypeSelectedUpdateCheckValidation(data) {
      this.exerciseTypeSelectedCheckValidation = data;
    },
    getExerciseTypeSelected(data) {
      this.exercise_type_selected = data;
    },
    workEnvironmentSelectedUpdateCheckValidation(data) {
      this.workEnvironmentSelectedCheckValidation = data;
    },
    getWorkEnvironmentSelected(data) {
      this.work_environment_selected = data;
    },
    industrySectorSelectedUpdateCheckValidation(data) {
      this.industrySectorSelectedCheckValidation = data;
    },
    getIndustrySectorSelected(data) {
      this.industry_sector_selected = data;
    },
    exerciseLevelSelectedUpdateCheckValidation(data) {
      this.exerciseLevelSelectedCheckValidation = data;
    },
    getExerciseLevelSelected(data) {
      this.exercise_level_selected = data;
    },
    businessFunctionSelectedUpdateCheckValidation(data) {
      this.businessFunctionSelectedCheckValidation = data;
    },
    getBusinessFunctionSelected(data) {
      this.business_function_selected = data;
    },
  },
};
</script>
